import React from 'react';
import { useState, useEffect } from "react";
import {useParams } from 'react-router-dom';
import Swal from "sweetalert2";
import { Row, Col, Button } from "reactstrap";
import Sidebar from '../../Sidebar';
import { useNavigate } from 'react-router';
import { useCookies } from 'react-cookie';
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import { moment } from 'moment';
import { useLocation, Link } from 'react-router-dom';
import ErrorToast from '../../ErrorToast';
import { getAllCompanies } from '../../services/CompanyServices';
import { getAllTax } from "../../services/TaxServices";
import { getAllProducts } from '../../services/ProductServices';
import { getUserAllowedPlants } from '../../services/PlantServices'
import FloatingControls from '../../components/FloatingControls';
import { getDisplayDate } from '../../utils/DateUtils';
import { getGroupsForCategory } from '../admin/GroupUtils';
import { getAllPermission } from '../../services/PermissionServices';
import {displayErrorToast,parseBoolean,displayError} from '../../helpers';
import StatusDropDown from '../../components/StatusDropDown';
import SummaryIcon from '../../components/SummaryIcon';
import { getHTMLForSummaryPopup } from '../../utils/PopupUtils';
import { getAllVendors,getVendorDetails } from '../../services/VendorServices';
import { getCurrentTime } from '../../utils/DateUtils';
import {getPurchaseOrderDetails,updatePurchaseOrder,deletePurchaseOrder} from '../../services/PurchaseOrderServices'
import "../../button.css";
import TableRowsPurchaseOrderEdit from './TableRowsPurchaseOrderEdit';
import EditSharpIcon from '@mui/icons-material/EditSharp';
import PremiumPageHeader from '../../components/PremiumPageHeader';

const toAmount = (value) => {
    const n = parseFloat(value);
    return Number.isFinite(n) ? n : 0;
};

function PurchaseOrderEdit(){
    const [inputs, setInputs] = useState({
        company_id:'',
        vendor_id:'',
        order_no:'',
        order_date:'',
        prefix:'',
        indent_date:'',
        quotation_date:'',
        validity_date:'',
        transport_mode:'own',
        terms_and_condition:'',
        pay_terms:'0',
        is_tax_included:true,
        status:true,
        indent_no:'',
        quotation_no:'',
    });
    const [company, setcompany] = React.useState([]);
    const [vendor, setvendor] = React.useState([]);
    const [plant, setplant] = React.useState([]);
    const Option = (props) => {
        return (
            <>
                <components.Option {...props}>
                    <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}/>{" "}
                    <label>{props.label}</label>
                    </components.Option>
            </>
        );
    };
    const [taxes, setTaxes] = React.useState([]);
    const [products, setProducts] = React.useState([]);
    const [productCategories, setProductCategories] = React.useState([]);
    // const [categories, setCategories] = React.useState([]);
    const [taxDetails,setTaxDetails] = React.useState([]);
    const [tcsTaxes, setTcsTaxes] = React.useState([]);
    
    React.useEffect(() => {
        getAllCompanies(cookies)
        .then (
            companyList => {
                const company = companyList.company_data.filter(obj => obj.status).map(
                    company => {
                        return { value: company.id, label: company.entity_name }
                    }
                );
                setcompany(company);
            }
        )
    }, []);

    React.useEffect(() => {
        getAllVendors(cookies)
        .then (
            vendorList => {
                
                const vendor = vendorList.vendor_list.filter(obj => obj.status).map(
                    vendor => {
                        return { value: vendor.id, label: vendor.entity_name }
                    }
                );
                setvendor(vendor);
            }
        )
    }, []);
    
    React.useEffect(() => {
        getUserAllowedPlants(cookies)
        .then (
            plantList => {
                
                const plant = plantList.plant_list.filter(obj => obj.status).map(
                    plant => {
                        return { value: plant.id, label: plant.plant_alias }
                    }
                );
                setplant(plant);
            }
        )
    }, []);
    
    React.useEffect(() => {
        getAllTax(cookies)
        .then (
            TaxList => {
                const taxes = TaxList.tax_list.filter(obj => obj.status).map(
                    tax => {
                        return { value: tax.id, label: tax.name }
                    }
                );
                setTaxes(taxes);
                const tcsTaxes = TaxList.tax_list.filter(obj => (obj.status && obj.tax_type==='tcs')).map(
                    tax => {
                        return { value: tax.id, label: tax.name }
                    }
                );
                console.log(JSON.stringify(tcsTaxes)+"tcsTaxes");
                setTaxDetails(TaxList.tax_list);
                setTcsTaxes(tcsTaxes);
            }
        )
    }, []);

    React.useEffect(() => {
        getAllProducts(cookies)
        .then (
            productList => {
                const products = productList.product_list.filter(obj => obj.status);
                setProducts(products);
            }
        )
    }, []);

    React.useEffect(() => {
        getGroupsForCategory('PRODUCT', cookies)
        .then(productCategories => {
            console.log(JSON.stringify(productCategories)+"productCategories")
            setProductCategories(productCategories.map(
                category => {
                    return { value: category.id, label: category.entity_name }
                }
            ));
        })
    }, []);

    // React.useEffect(() => {
    //     getAllPermission(cookies)
    //     .then (
    //         categoryList => {
    //             const categories = categoryList.group_list.map(
    //                 category => {
    //                     return { value: category.id, label: category.name }
    //                 }
    //             );
    //             setCategories(categories);
    //         }
    //     )
    // }, []);

    const [filteredProducts, setFilteredProducts] = React.useState([]);
    const [selectedVendor,setSelectedVendor] = useState({});
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null); 
    const [category] = useCookies(['myCategory']);
    const [superuser] = useCookies(['mySuperuser']);
    const [cookies] = useCookies(['myToken']);
    const [error, setError] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [Appr_so_dtl, setAppr_so_dtl] = React.useState([]);
    const [isChecked, setIsChecked] = useState({
        chkbx: false
    })
    const navigate = useNavigate();

    const showVendorDetails = () => {
        if (!selectedVendor || !selectedVendor.id) {
            // If no vendor is selected, do nothing
            return;
        }
        Swal.fire({
            html: getHTMLForSummaryPopup(
                'VENDOR DETAILS',
                [
                    { label: 'ADDRESS', value: selectedVendor.address_1 },
                    { value: selectedVendor.address_2 },
                    { value: selectedVendor.address_3 },
                    { label: 'GST', value: selectedVendor.gst_no },
                    { label: 'PAN', value: selectedVendor.pan_no },
                    { label: 'CONTACT PERSON NAME', value: selectedVendor.contact_person },
                    { label: 'DESIGNATION', value: selectedVendor.contact_designation }
                ]
            )
        }, '', 'info');
    }

    const handleChangeVendorDetails = (event) => {
        console.log(event.target.value);
        const vendorId = event.target.value;
        const propertyName = event.target.name;
        setInputs(values => ({ ...values, [propertyName]: vendorId }));
        if (vendorId) {
            //Get the details of the vendor using the Id
            getVendorDetails(cookies, vendorId)
                .then(vendorObject => {
                    // Set the details of the vendor in the state
                    setSelectedVendor(vendorObject);
                });
        } else {
            // Set selectedVendor to an empty object when no vendor is selected
            setSelectedVendor({});
        }
    }

    const handleChangeTableProduct = (index, evnt)=>{
        const { name, value } = evnt.target;
        const label = evnt.target.options[evnt.target.selectedIndex].text;
        console.log(evnt.target.options[evnt.target.selectedIndex].text)
        const rowsInput = [...rowsData];
        rowsInput[index][name] = value;
        if(label =='TRANSPORT CHARGES' || label=='PUMPING CHARGES'){
            rowsInput[index]['quantity'] = 1;
            rowsInput[index]['rate'] = 0;
            rowsInput[index]['amount'] = 0;
        }
        else{
            rowsInput[index]['quantity'] = 0;
            rowsInput[index]['rate'] = 0;
            rowsInput[index]['amount'] = 0;
        }
        var grandTotal = 0;
        for(var i=0; i<rowsData.length; i++) 
        {
            if((rowsData[i].amount) == '') 
            {
                rowsData[i].amount=0 
            }
            grandTotal += parseFloat(rowsData[i].amount)
        }
        console.log(grandTotal+"grandTotal");
        setInputs(values => ({...values, ['product_amount']: grandTotal.toFixed(2),['order_amount']:grandTotal.toFixed(2)}))
   
        console.log(name+"name")
        console.log(value+"value")
        console.log(JSON.stringify(products)+"products")
        rowsInput[index]['unit'] = value?products.filter(product =>product.id === parseInt(value))[0].unit.symbol:"";
        setRowsData(rowsInput);
    }

    const onCategorySelect = (selected) => {
        setSelectedCategory(selected);
        let filteredPrds = filterProductsByCategory(selected);
        console.log(JSON.stringify(products)+"products onCategorySelect")
        console.log(JSON.stringify(selected)+"selected")
        console.log(JSON.stringify(filteredPrds)+"filteredPrds")
        setFilteredProducts(filteredPrds);
        console.log(JSON.stringify(rowsData)+"rowsData onCategorySelect")
        setRowsData(rowsData.map((quolist,index)=>({...quolist,unit:quolist.product_id?quolist.unit:''})));
        // rowsInput[index]['unit'] = value?products.filter(product =>product.id === parseInt(value))[0].unit.symbol:"";
    };

    React.useEffect(() => {
        var today = new Date().getFullYear()+'-'+("0"+(new Date().getMonth()+1)).slice(-2)+'-'+("0"+new Date().getDate()).slice(-2)
        console.log(today+"date")
        console.log(typeof(today)+"typeof today")
        setInputs(values => ({...values, ['order_date']: today}))
    }, []);
    
    React.useEffect(() => {
        var today = new Date().getFullYear()+'-'+("0"+(new Date().getMonth()+1)).slice(-2)+'-'+("0"+new Date().getDate()).slice(-2)
        console.log(today+"date")
        console.log(typeof(today)+"typeof today")
        setInputs(values => ({...values, ['indent_date']: today}))
            }, []);

    React.useEffect(() => {
        var today = new Date().getFullYear()+'-'+("0"+(new Date().getMonth()+1)).slice(-2)+'-'+("0"+new Date().getDate()).slice(-2)
        console.log(today+"date")
        console.log(typeof(today)+"typeof today")
        setInputs(values => ({...values, ['quotation_date']: today}))
                }, []);
    
    React.useEffect(() => {
        var today = new Date();
        const purchaseOrderDate = new Date(inputs.order_date);
        const validityDate = new Date(purchaseOrderDate.getTime() + (30 * 24 * 60 * 60 * 1000));
        const validityDateString = validityDate.getFullYear() + '-' + ("0" + (validityDate.getMonth() + 1)).slice(-2) + '-' + ("0" + validityDate.getDate()).slice(-2);
    },[inputs.order_date])
    
    const [maxDate, setMaxDate] = React.useState("");
        React.useEffect(() => {
            const today = new Date().toISOString().split("T")[0];
            setMaxDate(today);
        }, []);

        React.useEffect(() => {
            setInputs(values => ({...values, 
                ['order_time']: getCurrentTime()
            }))
        }, []);

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
    
        if(name === "company_id") {
            if(value){
                console.log(inputs.order_date+"order_date")
                var t = inputs.order_date
                console.log(t.toString()+"toString"); 
                var moment = require('moment');
                var c=moment(t).format("DD-MM-YYYY");
                console.log(c+"c"+typeof(c))
            } else{
                setInputs(values => ({
                    ...values,
                    ['order_no']: '',
                    ['purchase_order_number']: '',
                    ['prefix']: ''
                }));
            }
        }
        else if(name === "order_date"){
            console.log(value+"order_date value"+typeof(value))
            var s = value
            console.log(s.toString()+"s.toString"); 
            var moment = require('moment');
            var d=moment(s).format("DD-MM-YYYY");
            console.log(d+"d"+typeof(d))
        }
        else if(name==='freight_charges'){
            outertableTaxCalculation(inputs.tcs_id,value)
        }
        else if(name==='tcs_id'){
            outertableTaxCalculation(value,inputs.freight_charges)
        }
        else if (name==='is_tax_included'){
            TaxCalculation(value,rowsData)
        }
        setInputs(values => ({...values, [name]: event.target.value}))
    }

    const handleChangeTableDetails = (index, evnt)=>{
        const { name, value } = evnt.target;
        const rowsInput = [...rowsData];
        rowsInput[index][name] = value;
        if((name === 'tax_id')&&(value)){
            // console.log(JSON.stringify(taxDetails)+"taxDetails")
            tableTaxCalculation(value,rowsInput[index]['quantity'],rowsInput[index]['rate'],index)
        }
        else if((name === 'quantity'))
        {
            console.log(value+"quantity")
            var amount=toAmount(value)*toAmount(rowsInput[index]['rate'])
            rowsInput[index]['amount']= amount.toFixed(2);
            if (rowsInput[index]['tax_id']){
            tableTaxCalculation(rowsInput[index]['tax_id'],value,rowsInput[index]['rate'],index)
            }
        }
        else if((name === 'rate'))
        {
            var amount=toAmount(value)*toAmount(rowsInput[index]['quantity'])
            rowsInput[index]['amount']= amount.toFixed(2);
            if (rowsInput[index]['tax_id']){
            tableTaxCalculation(rowsInput[index]['tax_id'],rowsInput[index]['quantity'],value,index)
            }
        }
        setRowsData(rowsInput);
    }
    const TaxCalculation=(is_tax_included,rows)=>{
        console.log(JSON.stringify(rows)+"rows");
        const updatedRows = rows.map(row => {
            if(row.tax_id){
                var selected_tax=taxDetails.find(obj=>obj.id===Number(row.tax_id));
                console.log(JSON.stringify(selected_tax)+"selected_tax");
                var tax_value2=selected_tax.tax_value2;
                var tax_value1=selected_tax.tax_value1;
            }else{
                var selected_tax={}
                var tax_value2=0;
                var tax_value1=0;
            }
            
            var tax_value=tax_value1+tax_value2;
            const rowRate = toAmount(row.rate);
            if(is_tax_included==='true'){
                var r = (100+tax_value) / 100
                var basic_rate=((rowRate / r)).toFixed(2);
                console.log("if")
            }
            else{
                var basic_rate=rowRate.toFixed(2);
                console.log("else")
            }
            var taxable_amt = parseFloat(basic_rate)*toAmount(row.quantity);
            if(selected_tax.tax_type==='igst'){
                var igst_per=tax_value1;
            }
            else{
                var igst_per=0
            }
            if(selected_tax.tax_type=='gst'){ 
                var cgst_per=tax_value1;
                var sgst_per=tax_value2;
            }
            else{
                var sgst_per=0;
                var cgst_per=0;
            }
            const sgst_amt=(taxable_amt*sgst_per/100).toFixed(2);
            const cgst_amt=((taxable_amt*cgst_per)/100).toFixed(2);
            const igst_amt=((taxable_amt*igst_per)/100).toFixed(2);
            const gst_amt=(parseFloat(cgst_amt)+parseFloat(sgst_amt)+parseFloat(igst_amt)).toFixed(2);
            const gross_amt=(parseFloat(gst_amt)+parseFloat(taxable_amt)).toFixed(2);
                return {
                    ...row,
                    taxable_amt: taxable_amt.toFixed(2),
                    gst_amt: gst_amt,
                    gross_amt: gross_amt,
                    cgst_amt:cgst_amt,
                    sgst_amt:sgst_amt,
                    igst_amt:igst_amt,
                    basic_rate:basic_rate
                };
        });
        setRowsData(updatedRows);
        console.log(is_tax_included+"is_tax_included")
        console.log(JSON.stringify(updatedRows)+"updatedRows")
        const totalAmounts = updatedRows.reduce((totals, row) => {
            return {
              taxable_amt: totals.taxable_amt + parseFloat(row.taxable_amt),
              cgst_amt: totals.cgst_amt + parseFloat(row.cgst_amt),
              sgst_amt: totals.sgst_amt + parseFloat(row.sgst_amt),
              igst_amt: totals.igst_amt + parseFloat(row.igst_amt),
              gst_amt: totals.gst_amt + parseFloat(row.gst_amt),
              gross_amt: totals.gross_amt + parseFloat(row.gross_amt)
            };
          }, { taxable_amt: 0, cgst_amt: 0, sgst_amt: 0, igst_amt: 0 ,gst_amt:0,gross_amt:0});
          console.log(JSON.stringify(totalAmounts)+"totalAmounts close Dc")
          // Update the state with the calculated sums
          if(inputs.tcs_id){
            var tcs_tax=taxDetails.find(obj=>obj.id===Number(inputs.tcs_id));
            console.log(JSON.stringify(tcs_tax)+"tcs_tax");
            var tcs_per = tcs_tax.tax_value1;
          }
          else{
            var tcs_per = 0;
          }
          console.log(tcs_per,totalAmounts.taxable_amt,totalAmounts.gst_amt+"tcs_per,totalAmounts.taxable_amt,totalAmounts.gst_amt");
          
          var tcs_amt = (parseFloat(tcs_per/100)*parseFloat(totalAmounts.taxable_amt + totalAmounts.gst_amt)).toFixed(2);
          console.log(tcs_amt,inputs.freight_charges+"tcs_amt,freight_charges")
          if(!(inputs.freight_charges)){
            var freight_charges = 0;
          }
          else{
            var freight_charges =inputs.freight_charges
          }
          var gross_amt = (parseFloat(totalAmounts.taxable_amt)+ parseFloat(totalAmounts.gst_amt)+parseFloat(tcs_amt)+parseFloat(freight_charges));
          setInputs(prevInputs => ({
            ...prevInputs,
            taxable_amt: totalAmounts.taxable_amt.toFixed(2),
            cgst_amt: totalAmounts.cgst_amt.toFixed(2),
            sgst_amt: totalAmounts.sgst_amt.toFixed(2),
            igst_amt: totalAmounts.igst_amt.toFixed(2),
            gst_amt: totalAmounts.gst_amt.toFixed(2),
            tcs_amt:tcs_amt,
            tcs_per:tcs_per,
            gross_amt:  gross_amt.toFixed(2),
            order_amount:Math.round(gross_amt).toFixed(2),
            rounded_off:(Math.round(gross_amt)-(gross_amt)).toFixed(2)
          }));
    }

    const outertableTaxCalculation=(tcs_id,freight_charges)=>{
        console.log(tcs_id,freight_charges+"tcs_id,freight_charges")
          if(tcs_id){
            var tcs_tax=taxDetails.find(obj=>obj.id===Number(tcs_id));
            console.log(JSON.stringify(tcs_tax)+"tcs_tax");
            var tcs_per = tcs_tax.tax_value1;
          }
          else{
            var tcs_per = 0;
          }
          if(!freight_charges){
            var freight_charges = 0;
          }
          console.log(tcs_per,inputs.taxable_amt,inputs.gst_amt+"tcs_per,inputs.taxable_amt,totalAmounts.gst_amt");
          
          var tcs_amt = (parseFloat(tcs_per/100)*(parseFloat(inputs.taxable_amt) + parseFloat(inputs.gst_amt))).toFixed(2);
          console.log(tcs_amt+"tcs_amt")
          var gross_amt = (parseFloat(inputs.taxable_amt)+ parseFloat(inputs.gst_amt)+parseFloat(tcs_amt)+parseFloat(freight_charges));
          setInputs(prevInputs => ({
            ...prevInputs,
            tcs_amt:tcs_amt,
            tcs_per:tcs_per,
            gross_amt:  gross_amt.toFixed(2),
            order_amount:Math.round(gross_amt).toFixed(2),
            rounded_off:(Math.round(gross_amt)-(gross_amt)).toFixed(2)
          }));
    }

    const tableTaxCalculation=(tax_id,quantity,rate,index)=>{
        const rateNum = toAmount(rate);
        const qtyNum = toAmount(quantity);
        const rowsInput = [...rowsData];
        console.log(tax_id,qtyNum,rateNum,index+",tax_id,quantity,rate,index",typeof(qtyNum),typeof(rateNum))
        var selected_tax=taxDetails.find(obj=>obj.id===Number(tax_id));
        console.log(JSON.stringify(selected_tax)+"selected_tax");
        var tax_value2=selected_tax.tax_value2;
        var tax_value1=selected_tax.tax_value1;
        var tax_value=tax_value1+tax_value2;
        if (inputs.is_tax_included){
            var r = (100+tax_value) / 100
            var basic_rate=((rateNum / r)).toFixed(2)
        }
        else{
            console.log(rateNum+"rate")
            var basic_rate=rateNum.toFixed(2)
        }
        var taxable_amt = parseFloat(basic_rate)*qtyNum;
        if(selected_tax.tax_type==='igst'){
            var igst_per=tax_value1;
        }
        else{
            var igst_per=0
        }
        if(selected_tax.tax_type=='gst'){ 
            var cgst_per=tax_value1;
            var sgst_per=tax_value2;
        }
        else{
            var sgst_per=0;
            var cgst_per=0;
        }
        rowsInput[index]['basic_rate']=basic_rate;
        rowsInput[index]['sgst_amt']=(taxable_amt*sgst_per/100).toFixed(2);
        rowsInput[index]['cgst_amt']=((taxable_amt*cgst_per)/100).toFixed(2);
        rowsInput[index]['igst_amt']=((taxable_amt*igst_per)/100).toFixed(2);
        rowsInput[index]['gst_amt']=(parseFloat(rowsInput[index]['cgst_amt'])+parseFloat(rowsInput[index]['sgst_amt'])+parseFloat(rowsInput[index]['igst_amt'])).toFixed(2);
        rowsInput[index]['gross_amt']=(parseFloat(rowsInput[index]['gst_amt'])+parseFloat(taxable_amt)).toFixed(2);
        rowsInput[index]['taxable_amt']=(taxable_amt).toFixed(2);
        console.log(JSON.stringify(rowsData)+"rowsData");
        const totalAmounts = rowsData.reduce((totals, row) => {
            return {
              taxable_amt: totals.taxable_amt + parseFloat(row.taxable_amt),
              cgst_amt: totals.cgst_amt + parseFloat(row.cgst_amt),
              sgst_amt: totals.sgst_amt + parseFloat(row.sgst_amt),
              igst_amt: totals.igst_amt + parseFloat(row.igst_amt),
              gst_amt: totals.gst_amt + parseFloat(row.gst_amt),
              gross_amt: totals.gross_amt + parseFloat(row.gross_amt)
            };
          }, { taxable_amt: 0, cgst_amt: 0, sgst_amt: 0, igst_amt: 0 ,gst_amt:0,gross_amt:0});
          console.log(JSON.stringify(totalAmounts)+"totalAmounts close Dc")
          // Update the state with the calculated sums
          if(inputs.tcs_id){
            var tcs_tax=taxDetails.find(obj=>obj.id===Number(inputs.tcs_id));
            console.log(JSON.stringify(tcs_tax)+"tcs_tax");
            var tcs_per = tcs_tax.tax_value1;
          }
          else{
            var tcs_per = 0;
          }
          console.log(tcs_per,totalAmounts.taxable_amt,totalAmounts.gst_amt+"tcs_per,totalAmounts.taxable_amt,totalAmounts.gst_amt");
          
          var tcs_amt = (parseFloat(tcs_per/100)*parseFloat(totalAmounts.taxable_amt + totalAmounts.gst_amt)).toFixed(2);
            console.log(tcs_amt+"tcs_amt")
          if(!(inputs.freight_charges)){
            var freight_charges = 0;
          }
          else{
            var freight_charges =inputs.freight_charges
          }
          var gross_amt = (parseFloat(totalAmounts.taxable_amt)+ parseFloat(totalAmounts.gst_amt)+parseFloat(tcs_amt)+parseFloat(freight_charges));
          setInputs(prevInputs => ({
            ...prevInputs,
            taxable_amt: totalAmounts.taxable_amt.toFixed(2),
            cgst_amt: totalAmounts.cgst_amt.toFixed(2),
            sgst_amt: totalAmounts.sgst_amt.toFixed(2),
            igst_amt: totalAmounts.igst_amt.toFixed(2),
            gst_amt: totalAmounts.gst_amt.toFixed(2),
            tcs_amt:tcs_amt,
            tcs_per:tcs_per,
            gross_amt:  gross_amt.toFixed(2),
            order_amount:Math.round(gross_amt).toFixed(2),
            rounded_off:(Math.round(gross_amt)-(gross_amt)).toFixed(2)
          }));
        }
    
const handleSubmit=(event)=> {
    event.preventDefault();
    try{
        console.log(JSON.stringify(rowsData)+"rowsdata submit")
        const isSameTaxId = rowsData.every(row => Number(row.tax_id) === Number(rowsData[0].tax_id));
        console.log(isSameTaxId+"isSameTaxId"); // true or false
        if( (rowsData.length > 0)&& (isSameTaxId))
        {
            const EMPTY_STRING = '';
  
        if (Object.values(error).every((x) => !x) && isSubmitting) { 
    //If the fields are correct details it is valid choosing yes or no option,otherwise it is invalid
            Swal.fire({title: 'Do you want to Update?',  
            showCancelButton: true,  
            confirmButtonText: `Yes`,  
            cancelButtonText: `No`,
            }).then((result) => {  
              if (result.isConfirmed) { 
                var moment = require('moment')
                  console.log(JSON.stringify(inputs)+"inputsubmit")
                  updatePurchaseOrder(cookies, {

                    company_id: parseInt(inputs.company_id),
                    vendor_id: parseInt(inputs.vendor_id),
                    plant_id: parseInt(inputs.plant_id),
                    order_amount:parseFloat(inputs.order_amount),
                    pay_terms:parseInt(inputs.pay_terms),
                    order_no: inputs.order_no,
                    order_date: inputs.order_date ? getDisplayDate(inputs.order_date) : EMPTY_STRING,
                    prefix: inputs.prefix,
                    indent_date: inputs.indent_date ? getDisplayDate(inputs.indent_date) : EMPTY_STRING,
                    quotation_date: inputs.quotation_date ? getDisplayDate(inputs.quotation_date) : EMPTY_STRING,
                    validity_date: inputs.validity_date ? getDisplayDate(inputs.validity_date) : EMPTY_STRING,
                    order_time :inputs.order_time|| EMPTY_STRING,
                    // prod_category: inputs.prod_category,
                    // status: inputs.status,
                    indent_no: inputs.indent_no,
                    is_tax_included: parseBoolean(inputs.is_tax_included),
                    quotation_no: inputs.quotation_no,
                    transport_mode:inputs.transport_mode || EMPTY_STRING,
                                                // pay_terms: inputs.pay_terms || EMPTY_STRING,
                    terms_and_condition: inputs.terms_and_condition,
                    // productCategories:selectedCategory.map(product=>product.value),
                    tcs_id:inputs.tcs_id?parseInt(inputs.tcs_id):null,
                    term_1:inputs.term_1,
                    term_2:inputs.term_2,
                    term_3:inputs.term_3,
                    term_4:inputs.term_4,
                    term_5:inputs.term_5,
                    tcs_per:parseFloat(inputs.tcs_per),
                    taxable_amt:parseFloat(inputs.taxable_amt),
                    cgst_amt:parseFloat(inputs.cgst_amt),
                    sgst_amt: parseFloat(inputs.sgst_amt),
                    igst_amt:parseFloat(inputs.igst_amt),
                    gst_amt:parseFloat(inputs.gst_amt),
                    tcs_amt:parseFloat(inputs.tcs_amt),
                    gross_amt:parseFloat(inputs.gross_amt),
                    order_amount:parseFloat(inputs.order_amount),
                    rounded_off:parseFloat(inputs.rounded_off),
                    freight_charges:parseFloat(inputs.freight_charges),
                    order_list:rowsData.map(quolist=>({
                    id:quolist.id,
                    tax_id:parseInt(quolist.tax_id),
                                                    // _structure_id:parseInt(quolist.concrete_structure_id),
                                                    // delivery_mode:quolist.delivery_mode,
                    amount:parseFloat(quolist.amount),
                    rate:parseFloat(quolist.rate),
                     basic_rate:parseFloat(quolist.basic_rate),
                    quantity:parseFloat(quolist.quantity),
                    product_id:parseInt(quolist.product_id),
                    unit:parseInt(quolist.unit),
                    user_remarks:quolist.user_remarks,
                    taxable_amt: parseFloat(quolist.taxable_amt) ,
                    cgst_amt: parseFloat(quolist.cgst_amt),
                    sgst_amt: parseFloat(quolist.sgst_amt),
                    igst_amt: parseFloat(quolist.igst_amt),
                    gst_amt: parseFloat(quolist.gst_amt),
                    gross_amt:parseFloat(quolist.gross_amt)
                    })),
                    status: parseBoolean(inputs.status)
                 }, id)
                 //console.log(updateAccountMaster)
                .then(response => {
                    console.log("Update response:", response);
                    Swal.fire("Updated!", "", "success");
                    view();
                }).catch((error) => {
                    console.log(error.response.data);
                    displayError(error.response.data,"Updated Failed");
                });
                
              } 
              else if (result.isDismissed) {
                Swal.fire("Not Updated", "", "info");
              }
            });
      
      }
        }
        else if(!((rowsData.length > 0)))
        {
        Swal.fire('Please add atleast  one product', '', 'info')   
        }
        else if(!(isSameTaxId))
        {
        Swal.fire('Same tax is only allowed.', '', 'info')   
        }
}
catch (e) {
  displayErrorToast(e);
} 
}

    const Reload = () => {
        window.location.reload();
      }
      
    const [rowsData, setRowsData] = useState([]);
    const addTableRows = () => {
        const count=rowsData.length +1;
        const rowsInput={
                soDSqlNo:count,
                id:'',
                tax_id:0,
                soDConStruc:'',
                soDDeliveryMode:'',
                amount:'',
                rate:'',
                quantity:'',
                unit:'',
                product_id:'',
                user_remarks:''
            }
            setRowsData([...rowsData, rowsInput])
    }
    
    const Cancel = () => {
        setInputs({
            company_id:'',
            vendor_id:'',
            terms_and_condition:'',
            transport_mode:'',
            is_tax_included:'',
            pay_terms:'',
            order_no:'',
            order_date:'',
            prefix:'',
            indent_date:'',
            quotation_date:'',
            validity_date:'',
            indent_no:'',
            quotation_no:'',
            status:''
        })
        setRowsData([])
    }
    
    const [toDelete_DtlIds,settoDelete] = useState([]);
    
    const deleteTableRows = (index)=>{
        const rows = [...rowsData];
        console.log((rows[index].id)+"rowsData.id");
        if((rows[index].id))
        {
            Swal.fire({title: 'Are you sure to Delete this PO Detail?',  
            showCancelButton: true,  
            confirmButtonText: `Yes`,  
            cancelButtonText: `No`,
            }).then((result) => { 
                if (result.isConfirmed)
                {
                    settoDelete([...toDelete_DtlIds, rows[index].id])
                    rows.splice(index, 1);
                    for(var i=0; i<rows.length; i++) 
                    {
                        rows[i]['soDSqlNo']= i+1
                        // console.log(rowsData[i].so_amt+"rowsData.so_amt");
                    }
                    setRowsData(rows)
                    TaxCalculation(inputs.is_tax_included,rows)
                } 
            });
        }
        else
        {
            rows.splice(index, 1);
            
            for(var i=0; i<rows.length; i++) 
            {
                rows[i]['soDSqlNo']= i+1
                // console.log(rowsData[i].so_amt+"rowsData.so_amt");
            }
            setRowsData(rows)
            TaxCalculation(inputs.is_tax_included,rows)
        }
    }

    const view = () => {
        navigate('/PurchaseOrderTable')
    }

    const Back = () => {
        navigate('/Home')
    }

    const [isLoading, setIsLoading] = useState(true); 
    const onDeletePurchaseOrder = (event) => {
        event.preventDefault();
        Swal.fire({title: 'Are you sure to Delete?',  
        showCancelButton: true,  
        confirmButtonText: `Yes`,  
        cancelButtonText: `No`,
        }).then((result) => {  
          if (result.isConfirmed) { 
    
            setIsLoading(true);
            deletePurchaseOrder(cookies, id)
            .then(response => {
                console.log(`PurchaseOrder with id ${id} deleted`);
                Swal.fire('Deleted Successfully!', '', 'success');
                view();
            })
            .catch(error => {
                console.log(error.response.data);
                displayError(error.response.data,'Delete Failed');
            }); 
          } else if (result.isDismissed) {    
            Swal.fire('Not Deleted', '', 'info')  
        }
        });
    };

    const filterProductsByCategory = (selectedCategories, localProducts) => {

        let filteredPrds = [];
        if (!localProducts) {
            localProducts = products;
        }
        console.log(JSON.stringify(products)+" products filterProductsByCategory")
        console.log(JSON.stringify(selectedCategories)+"selectedCategories filterProductsByCategory ")
        
        selectedCategories.forEach(productCategory=>{
            
            let localList = localProducts.filter(product => product.category.id === productCategory.value)
            
                .map(
                    product => {
                        return { value: product.id, label: product.name }
                    }
                );
            filteredPrds=[...filteredPrds,...localList];
        });

        return filteredPrds;
    }

    
    const [inProgress, setInProgress] = useState(false);

    const {id}=useParams()
    React.useEffect(() => {
        const EMPTY_STRING = '';
        if (id)
        {
        setInProgress(true);
        getPurchaseOrderDetails(cookies, id)
        .then(response => {
            console.log(JSON.stringify(response))
            setInProgress(false);
            console.log(typeof(response.order_date)+"response.order_date");
            setInputs(values => ({...values,['id']:response.id,
            ['tcs_id']:response.tcs.id?response.tcs.id:null,
            ['company_id']: response.company.id, 
            ['vendor_id']: response.vendor.id,
            ['plant_id']:response.plant.id,
            ['order_no']:(response.prefix+response.order_no),  
            ['pay_terms']:response.pay_terms,
            ['transport_mode']:response.transport_mode,
            ['indent_no']:response.indent_no,
            ['quotation_no']:response.quotation_no,
            ['order_amount']:response.order_amount,
        //   ['status']:response.status,
            indent_date:(response.indent_date? getDisplayDate(response.indent_date) :EMPTY_STRING),
            quotation_date:(response.quotation_date? getDisplayDate(response.quotation_date) :EMPTY_STRING),
            validity_date:(response.validity_date? getDisplayDate(response.validity_date) :EMPTY_STRING),
            order_date:(response.order_date? getDisplayDate(response.order_date) :EMPTY_STRING),       
            ['is_tax_included']:response.is_tax_included,
            ['terms_and_condition']: response.terms_and_condition,
            ['prefix']:response.prefix,
            ['order_amount']: response.order_amount,
            ['term_1']: response.term_1,
            ['term_2']: response.term_2,
            ['term_3']: response.term_3,
            ['term_4']: response.term_4,
            ['term_5']: response.term_5,
            ['tcs_per']: response.tcs_per,
            ['taxable_amt']: response.taxable_amt,
            ['cgst_amt']: response.cgst_amt,
            ['sgst_amt']: response.sgst_amt,
            ['igst_amt']: response.igst_amt,
            ['gst_amt']: response.gst_amt,
            ['tcs_amt']: response.tcs_amt,
            ['gross_amt']: response.gross_amt,
            ['rounded_off']: response.rounded_off,
            ['freight_charges']: response.freight_charges,
            status:String(response.status)}));
            let categoryIds = [];
            let selectedCategories = [];
            response.order_list.forEach(order => {
                if (!categoryIds.includes(order.product.category.id)) {
                    selectedCategories.push({
                        value: order.product.category.id,
                        label: order.product.category.name
                    });
                    categoryIds.push(order.product.category.id);
                }
            });
        setSelectedCategory(selectedCategories);
        getAllProducts(cookies)
        .then(productList => {
            const activeProducts = productList.product_list.filter(obj => obj.status);
            console.log(JSON.stringify(selectedCategories)+"selectedCategories useeffect")
            let filteredPrds;
            if (selectedCategories.length === 0) {
                // If no categories are selected, remove product names
                filteredPrds = activeProducts.map(obj => ({ ...obj, name: "" }));
            } else {
                filteredPrds = filterProductsByCategory(selectedCategories, activeProducts);
            }
            // setProducts(filteredPrds);
            // setProducts(activeProducts);
            setFilteredProducts(filteredPrds);
        });
              setRowsData(response.order_list.map((quolist,index)=>({...quolist,soDSqlNo: index+1,
                // concrete_structure_id:quolist.concrete_structure.id,
                tax_id:quolist.tax.id,
                product_id:quolist.product.id,
                unit:quolist.product.unit.symbol,
                id:quolist.id,
                taxable_amt: quolist.taxable_amt,
                cgst_amt: quolist.cgst_amt,
                sgst_amt: quolist.sgst_amt ,
                igst_amt: quolist.igst_amt,
                gst_amt: quolist.gst_amt,
                gross_amt:quolist.gross_amt,
            basic_rate:quolist.basic_rate})));
                getVendorDetails(cookies, response.vendor.id)    
                .then(vendorObject => {              
                    setSelectedVendor(vendorObject)
                  })
          })
          .catch(error => {
              setInProgress(false);
              displayError(error.response.data, "Loading Failed");
            });
        }
    }, []);

    const [showModal, setShowModal] = useState(false);
    const handleDetailsIconClick = () => {
        setShowModal(true);
    };

    return (
        <>
            <div id="outer-container" className="App" >
                <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} /> 
                <ErrorToast/>
                <div id="page-wrap">
                    <form onSubmit={handleSubmit} >
                        <div className="premium-page-header-wrap">
              <PremiumPageHeader
                module="PURCHASE"
                title="Update Purchase Order"
                subtitle="Edit purchase order lines, taxes, and terms."
                modeLabel="EDIT MODE"
              />
            </div>
                        
                        <FloatingControls tableLink="/PurchaseOrderTable" onCancel={Cancel} enableCancel={true}/>
                        <div className="container form-control-panel">
                            <Row>
                                <Col xl={6} lg={12} md={12}>
                                    <div className="form-row table-bordered  shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel " >

                                        <label htmlFor="company_id" className="form-group col-sm-5 text-right">Office</label>
                                        <select id="company_id" name="company_id" className="form-control col-sm-6 browser-default custom-select mandatory-form-control" required onchange={handleChange} disabled={true} value={inputs.company_id || ""}>
                                            <option value="">Select Company</option>
                                            {company.map((item) => (
                                                <option key={item.value}value={item.value}>{item.label} </option>
                                            ))} 
                                        </select><br /> 
                                        
                                        <label htmlFor="vendor_id" className="form-group col-sm-5 text-right">Vendor Name</label>
                                        <select id="vendor_id" name="vendor_id" className="form-control col-sm-6 browser-default custom-select mandatory-form-control" required onChange={handleChangeVendorDetails} disabled={true} value={inputs.vendor_id || ""}>
                                            <option value="">Select Vendor  Name</option>
                                            {vendor.map((item) => (
                                                <option key={item.value} value={item.value}>{item.label}</option>
                                            ))}
                                        </select><SummaryIcon onClickHandler={showVendorDetails}/><br />

                                        
                                        <label htmlFor="plant_id" className="form-group col-sm-5 text-right">Delivery Place</label>
                                        <select id="plant_id" name="plant_id" className="form-control col-sm-6 browser-default custom-select mandatory-form-control" required onChange={handleChange}  value={inputs.plant_id || ""}>
                                            <option value="">Select Plant</option>
                                            {plant.map((item) => (
                                                <option key={item.value}value={item.value}>{item.label} </option>
                                            ))} 
                                        </select><br />
                                        <label htmlFor="order_list" className="form-group col-sm-5 text-right">Product Category</label>
                                    <ReactSelect
                                    options={productCategories}
                                    isMulti= {true}
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}
                                    components={{Option}}
                                    isClearable={true}
                                    defaultValue={selectedOption}
                                    value={selectedCategory}
                                    onChange={onCategorySelect}
                                    className={"mandatory-form-control form-control col-sm-6"}
                                    placeholder="Please select Category"
                                  /><br/>
                                  
                                        <EditSharpIcon color="#1565c0"  
                                        onClick={handleDetailsIconClick}  
                                        sx={{
                                            cursor: 'pointer'
                                        }} />

                                        <div className="modal" tabIndex="-1" style={{ display: showModal ? 'block' : 'none' }}>
                                            <div className="modal-dialog modal-xl" style={{ height: "500px"}}>
                                                <div className="modal-content">
                                                <div className="modal-body display" style={{backgroundColor:"pink" }}>
                                                    <Row> 
                                                    <Col xl={6} lg={12} md={12}> 
                                                        <div className="form-row table-bordered  shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel">
                                                        <label htmlFor="transport_mode" className="form-group col-sm-5 text-right">Mode Of Delivery</label>
                                                        <select id="transport_mode" name="transport_mode" className="form-control col-sm-6  browser-default custom-select" required onChange={handleChange} value={inputs.transport_mode || ""}>
                                                            <option value='own'>Own</option>
                                                            <option value="customer">Vendor</option>
                                                            <option value="own/customer">Own/Vendor</option>
                                                        </select><br />

                                                        <label htmlFor="pay_terms" className="form-group col-sm-5 text-right">Payment Terms (in Days)</label>
                                                        <input type="number" min="0"id="pay_terms" className="form-control col-sm-6"  placeholder="Please fill pay terms in days*" name="pay_terms" onChange={handleChange} value={inputs.pay_terms || 0}/><br/>
                                        
                                                        <label htmlFor="validity_date" className="form-group col-sm-5 text-right">Validity Date</label>
                                                        <input type="date" className="form-control col-sm-6"id="validity_date" name="validity_date"  onChange={handleChange} value={inputs.validity_date || ""}/><br/>
                                                        
                                                    
                                                        <label htmlFor="status" className="form-group col-sm-5 text-right ">Status </label>
                                                        <select required id="status" name="status" onChange={handleChange} value={inputs.status} className="browser-default custom-select col-sm-6 mandatory-form-control">
                                                            <option value='true'>Active</option>
                                                            <option value='false'>Inactive</option>
                                                        </select>

                                                        <label htmlFor="terms_and_condition" className="form-group col-sm-5 text-right">Remarks</label>
                                                        <textarea rows="1" cols="50" className="form-control col-sm-6" id="terms_and_condition" name="terms_and_condition" onChange={handleChange} value={inputs.terms_and_condition || ""}></textarea>
                                                        </div>  
                                                    </Col>
                                                    <Col xl={6} lg={12} md={12}> 
                                                        <div className="form-row table-bordered  shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel" >
                                                            <label htmlFor="indent_no" className="form-group col-sm-4 text-right">Indent No</label>
                                                            <input type="text" id="indent_no" name="indent_no" className="form-control col-sm-7" value={inputs.indent_no || ""} onChange={handleChange} placeholder="Enter Indent No"/><br />
                                                            
                                                            <label htmlFor="indent_date" className="form-group col-sm-4 text-right">Indent Date</label>
                                                            <input required type="date" id="indent_date" name="indent_date" onChange={handleChange} className="form-control col-sm-7" value={inputs.indent_date || ""} max={maxDate}   />
                    
                                                            <label htmlFor="quotation_no" className="form-group col-sm-4 text-right">Quotation No</label>
                                                            <input type="text" id="quotation_no" name="quotation_no" className="form-control col-sm-7" value={inputs.quotation_no || ""} onChange={handleChange} placeholder="Enter Quotation No"/><br />
                                                        
                                                            <label htmlFor="quotation_date" className="form-group col-sm-4 text-right">Quotation Date</label>
                                                            <input required type="date" id="quotation_date" name="quotation_date" onChange={handleChange} className="form-control col-sm-7" value={inputs.quotation_date || ""} max={maxDate}   />
                                                        </div>
                                                    </Col>
                                                    </Row>                   
                                                </div>
                                                <div className="text-center" style={{backgroundColor:"pink" }}>
                                                    <button type="button" className="btn btn-primary" onClick={() => setShowModal(false)}>Close</button>
                                                </div>
                                                </div>
                                            </div>
                                        </div>
                                </div> 
                                </Col>

                                <Col xl={6} lg={12} md={12}>

                                    <div className="form-row table-bordered shadow p-2 my-2  border-secondary p-2 mb-3 form-control-panel " >
                                        <label htmlFor="order_no" className="form-group col-sm-4 text-right">Purchase Order No</label>
                                        <input type="text" className="form-control col-sm-7" id="order_no" value={inputs.order_no || ""} disabled={true}  name="order_no" onChange={handleChange}/><br />

                                        <label htmlFor="order_date" className="form-group col-sm-4 text-right ">Date</label>
                                        <input required type="date" id="order_date" name="order_date" onChange={handleChange} className="form-control col-sm-7 mandatory-form-control" disabled={true} value={inputs.order_date || ""} max={maxDate} />
                                        <label htmlFor="is_tax_included" className="form-group col-sm-4 text-right">Is Inclusive of Taxes?</label>
                                        <select id="is_tax_included"className="form-control col-sm-7 browser-default custom-select " name="is_tax_included" onChange={handleChange} value={inputs.is_tax_included || "false"} >
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select><br/> 

                                        <label htmlFor="tcs_id" className="form-group col-sm-4 text-right">TCS Structure</label>
                                        <select name="tcs_id" id="tcs_id" className="browser-default custom-select form-control col-sm-7" onChange={handleChange} value={inputs.tcs_id || ""}   >
                                            <option value=''>Select Tax Code</option>
                                            {tcsTaxes.map((item) => (
                                                <option key={item.value} value={item.value}>
                                                {item.label}
                                                </option>
                                                    ))}
                                        </select>
                                    </div>
                                </Col>
                            </Row>

            <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue container table-responsive">
                <table className="table order-list" id="myTable" style={{textAlign:"center",borderRadius:"10px",backgroundColor:"RGB(188,232,253)"}}>
                     <thead>
                        <tr>
                            <th><button type="button"className="btn btn-success" onClick={addTableRows}>+</button></th>
                            <th colSpan="1">S.No.</th>
                            <th colSpan="1">Product</th>
                            <th colSpan="1">Unit</th>
                            <th colSpan="1">Order Qty.</th>
                            <th colSpan="1">Rate / M3 </th>
                            <th colSpan="1">Amount</th>
                            <th colSpan="1">Tax</th> 
                            <th colSpan="1">Remarks</th>
                        </tr>
                    </thead>
                    <tbody >
                    <TableRowsPurchaseOrderEdit rowsData={rowsData} deleteTableRows={deleteTableRows} handleChangeTableDetails={handleChangeTableDetails} handleChangeTableProduct={handleChangeTableProduct} products={filteredProducts} taxes={taxes} />
                    </tbody>
                </table>
                <table className="table order-list" id="myTable" style={{textAlign:"center",borderRadius:"10px",backgroundColor:"white",border:'4px solid rgb(235, 73, 73)'}}>
                        <tbody>
                        <tr >
                            <td colSpan="6"style={{textAlign:"right" ,backgroundColor:"white"}}><b>Total Taxable Amount </b></td>
                            <td colSpan="4"><input type="text" className='form-control' style={{ backgroundColor: "white",cursor: "not-allowed",textAlign:"right"}} value={inputs.taxable_amt || 0}></input></td>
                            <td colSpan="6"style={{textAlign:"right" ,backgroundColor:"white"}}><b>CGST Amount </b></td>
                            <td colSpan="4"><input type="text" className='form-control' style={{ backgroundColor: "white",cursor: "not-allowed",textAlign:"right" }} value={inputs.cgst_amt || 0}></input></td>
                        </tr>                          
                        <tr>
                            <td colSpan="6"style={{textAlign:"right" ,backgroundColor:"white"}}><b>IGST Amount  </b></td>
                            <td colSpan="4"><input type="text"  className='form-control' style={{ backgroundColor: "white",cursor: "not-allowed",textAlign:"right" }} value={inputs.igst_amt || 0}></input></td>
                            <td colSpan="6"style={{textAlign:"right" ,backgroundColor:"white"}}><b> SGST Amount  </b></td>
                            <td colSpan="4"><input type="text"  className='form-control' style={{ backgroundColor: "white",cursor: "not-allowed",textAlign:"right" }} value={inputs.sgst_amt || 0}></input></td>
                        </tr>
                        <tr>
                            <td colSpan="6"style={{textAlign:"right" ,backgroundColor:"white"}}><b>Total GST Amount  </b></td>
                            <td colSpan="4"><input type="text"  className='form-control' style={{ backgroundColor: "white",cursor: "not-allowed",textAlign:"right" }} value={inputs.gst_amt || 0}></input></td>
                            <td colSpan="6"style={{textAlign:"right" ,backgroundColor:"white"}}><b>TCS Amount  </b></td>
                            <td colSpan="4"><input type="text"  className='form-control' style={{ backgroundColor: "white",cursor: "not-allowed",textAlign:"right" }} value={inputs.tcs_amt || 0}></input></td>
                        </tr>
                        <tr>
                            <td colSpan="6"style={{textAlign:"right" ,backgroundColor:"white"}}><b>Freight Charges</b></td>
                            <td colSpan="4"><input type="number"  style={{ textAlign:"right" }}  className='form-control' value={inputs.freight_charges || 0} name="freight_charges" onChange={handleChange}/></td>
                            <td colSpan="6"style={{textAlign:"right" ,backgroundColor:"white"}}><b>Total Gross Amount  </b></td>
                            <td colSpan="4"><input type="text"  className='form-control' style={{ backgroundColor: "white",cursor: "not-allowed",textAlign:"right" }} value={inputs.gross_amt || 0}></input></td>
                        </tr>
                        <tr>
                            <td colSpan="6"style={{textAlign:"right" ,backgroundColor:"white"}}><b>Round off  </b></td>
                            <td colSpan="4"><input type="text"  className='form-control'style={{ backgroundColor: "white",cursor: "not-allowed",textAlign:"right" }} value={inputs.rounded_off || 0}></input></td>
                            <td colSpan="6"style={{textAlign:"right" ,backgroundColor:"white"}}><b>Total Order Amount  </b></td>
                            <td colSpan="4"><input type="text"  className='form-control' style={{ backgroundColor: "white",cursor: "not-allowed",textAlign:"right" }} value={inputs.order_amount || 0}></input></td>
                        </tr>
                        </tbody> 
                    </table>
                   </div>  
                   <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel" >
                    <label htmlFor="term_1" className="form-group col-sm-1 text-left">Term 1</label>
                    <input type="text" id="term_1" name="term_1" className="form-control col-sm-11" value={inputs.term_1 || ""} onChange={handleChange} placeholder="Enter terms"/><br />
                    
                    <label htmlFor="term_2" className="form-group col-sm-1 text-left">Term 2</label>
                    <input type="text" id="term_2" name="term_2" className="form-control col-sm-11" value={inputs.term_2 || ""} onChange={handleChange} placeholder="Enter terms"/><br />
                    
                    <label htmlFor="term_3" className="form-group col-sm-1 text-left">Term 3</label>
                    <input type="text" id="term_3" name="term_3" className="form-control col-sm-11" value={inputs.term_3 || ""} onChange={handleChange} placeholder="Enter terms"/><br />
                    
                    <label htmlFor="term_4" className="form-group col-sm-1 text-left">Term 4</label>
                    <input type="text" id="term_4" name="term_4" className="form-control col-sm-11" value={inputs.term_4 || ""} onChange={handleChange} placeholder="Enter terms"/><br />
                    
                    <label htmlFor="term_5" className="form-group col-sm-1 text-left">Term 5</label>
                    <input type="text" id="term_5" name="term_5" className="form-control col-sm-11" value={inputs.term_5 || ""} onChange={handleChange} placeholder="Enter terms"/><br />
                    </div>
                        </div>
                        <div className="footer text-center">
                            <Button  type="submit"  style={{width:"80px",fontWeight:"bold",backgroundColor:"RGB(58,29,238,0.8)"}} className="btn btn-twitter">Update</Button> &nbsp;&nbsp;               
                            <Button   type="button"style={{width:"80px",fontWeight:"bold",backgroundColor:"RGB(58,29,238,0.8)"}} className="btn btn-twitter"onClick={view}>View</Button>&nbsp;&nbsp;
                            <Button  type="button"style={{width:"80px",fontWeight:"bold",backgroundColor:"RGB(58,29,238,0.8)"}} className="btn btn-twitter"onClick={Back}>Home</Button>&nbsp;&nbsp;
                            <Button className="btn btn-delete"  type="button"style={{width:"80px",fontWeight:"bold"}} onClick={onDeletePurchaseOrder}>Delete</Button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
                                }

export default PurchaseOrderEdit

